import { WidgetConfig } from '@/components/widgets/types'

const STORAGE_KEY = 'dashboard-config'

export interface DashboardConfig {
  id: string
  name: string
  widgets: WidgetConfig[]
  createdAt: string
  updatedAt: string
}

export const dashboardConfigService = {
  // Save dashboard configuration
  saveConfig: (name: string, widgets: WidgetConfig[]): DashboardConfig => {
    const config: DashboardConfig = {
      id: `dashboard-${Date.now()}`,
      name,
      widgets,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    }

    // Save to localStorage
    const savedConfigs = dashboardConfigService.getAllConfigs()
    savedConfigs.push(config)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(savedConfigs))

    return config
  },

  // Get all saved configurations
  getAllConfigs: (): DashboardConfig[] => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      return stored ? JSON.parse(stored) : []
    } catch {
      return []
    }
  },

  // Get a specific configuration
  getConfig: (id: string): DashboardConfig | null => {
    const configs = dashboardConfigService.getAllConfigs()
    return configs.find((c) => c.id === id) || null
  },

  // Update a configuration
  updateConfig: (id: string, updates: Partial<DashboardConfig>): DashboardConfig | null => {
    const configs = dashboardConfigService.getAllConfigs()
    const index = configs.findIndex((c) => c.id === id)
    if (index === -1) return null

    configs[index] = {
      ...configs[index],
      ...updates,
      updatedAt: new Date().toISOString(),
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(configs))
    return configs[index]
  },

  // Delete a configuration
  deleteConfig: (id: string): boolean => {
    const configs = dashboardConfigService.getAllConfigs()
    const filtered = configs.filter((c) => c.id !== id)
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered))
    return filtered.length < configs.length
  },

  // Get default configuration
  getDefaultConfig: (): WidgetConfig[] => {
    return [
      {
        id: 'kpi-deposits',
        type: 'kpi-scorecard',
        title: 'Total Deposits',
        position: { x: 0, y: 0 },
        size: { width: 1, height: 1 },
        refreshInterval: 60,
        filters: [],
        settings: { metricId: 'deposits' },
        visible: true,
      },
      {
        id: 'kpi-withdrawals',
        type: 'kpi-scorecard',
        title: 'Total Withdrawals',
        position: { x: 0, y: 0 },
        size: { width: 1, height: 1 },
        refreshInterval: 60,
        filters: [],
        settings: { metricId: 'withdrawals' },
        visible: true,
      },
      {
        id: 'kpi-net-flow',
        type: 'kpi-scorecard',
        title: 'Net Flow',
        position: { x: 0, y: 0 },
        size: { width: 1, height: 1 },
        refreshInterval: 60,
        filters: [],
        settings: { metricId: 'net-flow' },
        visible: true,
      },
      {
        id: 'activity-feed',
        type: 'activity-feed',
        title: 'Activity Feed',
        position: { x: 0, y: 0 },
        size: { width: 2, height: 1 },
        refreshInterval: 30,
        filters: [],
        settings: { maxItems: 50, autoScroll: true },
        visible: true,
      },
      {
        id: 'alert-center',
        type: 'alert-center',
        title: 'Alerts',
        position: { x: 0, y: 0 },
        size: { width: 1, height: 1 },
        refreshInterval: 60,
        filters: [],
        settings: { maxAlerts: 10 },
        visible: true,
      },
    ]
  },
}


